import src from "IMAGE";
export default { src, width: 452, height: 205, blurWidth: 0, blurHeight: 0};
